const NETWORK_ERROR_PATTERNS = [
  'Failed to fetch', // Chrome / Chromium
  'NetworkError', // Firefox ("NetworkError when attempting to fetch resource")
  'Load failed', // Safari / iOS
  'Unable to reach the server', // Our own transformed message (useGetApi)
];

export function isNetworkError(message: string): boolean {
  return NETWORK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
}
